import React, { useEffect, useState } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import { isEmpty } from '../helper/utils';
import { getProtectedData } from '../services/api';
import Maps from './loadmonitoring/Maps';

// TODO: get facility coordinates, live status from backend and only show those
const facilities = [
  // { shortName: "mbs", fullName: "Marina Bay Sands", yRange: [0, 17000], position: [1.2838, 103.8591], status: "live" },
  // { shortName: "orq", fullName: "One Raffles Quay", yRange: [0, 15000], position: [1.2811, 103.8517], status: "live" },
  { shortName: "mrwps", fullName: "Marina Raw Water Pumping Station", yRange: [0, 4000], position: [1.2807, 103.8711], status: "live" },
  { shortName: "cwrp", fullName: "Changi Water Reclamation Plant", yRange: [0, 40000], position: [1.313611, 104.001389], status: "live" },
  { shortName: "hvps", fullName: "Holland Pumping Station", yRange: [0, 800], position: [1.311438, 103.802332], status: "live" },
  // { shortName: "bess", fullName: "Battery Energy Storage System", yRange: [0, 3000], position: [1.4467, 103.77385], status: "live" },
];

const LoadMonitoring = ({ refresh }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      const response = await getProtectedData("/getFacilityData/");
      console.log("API response:", response.response);
      if (response.isOk && !isEmpty(response.response)) {
        const rawData = response.response;
        
        // Process each facility's data individually
        Object.keys(rawData).forEach(facilityKey => {
          const facilityData = rawData[facilityKey]?.data;
          if (Array.isArray(facilityData) && facilityKey === "cwrp") {
            // Combine if it's a split facility (like "cwrp")
            rawData.cwrp = combineDataByInterval(facilityKey, rawData.cwrpeast?.data, rawData.cwrpwest?.data);
            delete rawData.cwrpeast;
            delete rawData.cwrpwest;
          } else if (Array.isArray(facilityData)) {
            rawData[facilityKey].data = combineDataByInterval(facilityKey,facilityData);
          }
        });
  
        setData(rawData);
      } else {
        setData({});
      }
    })();
  }, [refresh]);
  
  const combineDataByInterval = (facilityName, data1, data2 = []) => {
    const combinedData = {};
  
    const parseTime = (time) => new Date(`1970-01-01T${time}Z`);
    const formatTime = (date) => date.toISOString().substr(11, 8);
  
    const aggregateData = (data) => {
      if (!Array.isArray(data)) {
        console.error('Data is not an array:', data);
        return;
      }
      data.forEach(d => {
        const time = parseTime(d.time);
        const roundedTime = new Date(Math.floor(time.getTime() / (5 * 60 * 1000)) * (5 * 60 * 1000));
        const timeString = formatTime(roundedTime);
        if (!combinedData[timeString]) {
          combinedData[timeString] = { time: timeString, power_kw_field: 0 };
        }
        combinedData[timeString].power_kw_field += d.power_kw_field;
      });
    };
  
    // Aggregate both data arrays (data1 and optional data2)
    if (Array.isArray(data1)) aggregateData(data1);
    if (Array.isArray(data2)) aggregateData(data2);
  
    // Prepare combined data output
    const sortedCombinedData = Object.values(combinedData).sort((a, b) => new Date(`1970-01-01T${a.time}Z`) - new Date(`1970-01-01T${b.time}Z`));
    
    // Log the facility name and combined data output
    // console.log(`Combined data for ${facilityName}:`, sortedCombinedData);
  
    return sortedCombinedData;
  };
  

  return data === null ? (
    <Spinner animation="border" variant="primary" />
  ) : (
    <Container fluid className="h-100 p-0">
      {/* {console.log("Facilities passed to Maps:", facilities)}
      {console.log("Facility data passed to Maps:", data)} */}
      <Container fluid className="h-100 p-0 position-relative">
        <Maps facilities={facilities} facilityData={data} />
      </Container>
    </Container>
  );
  
};

export default LoadMonitoring;